import { GenericMedicalList } from "./GenericMedicalList";

const DIRECTIVE_TYPES = [
  "Living Will", "Healthcare Proxy or POA", "DNR (Do Not Resuscitate)",
  "DNI (Do Not Intubate)", "POLST (Physician Orders for Life-Sustaining Treatment)",
  "MOLST (Medical Orders for Life-Sustaining Treatment)",
  "Psychiatric Advance Directive", "Organ Donation", "Mental Health Declaration",
];
const STATUSES = ["Active", "Revoked", "Expired", "Pending"];

const DEFAULT = { directive_type: "", status: "Active", executed_date: "",
                  reviewed_date: "", expires_date: "", agent_name: "", agent_phone: "",
                  agent_relationship: "", document_location: "", notes: "" };

const COLUMNS = [
  { key: "directive_type", label: "Type" },
  { key: "status", label: "Status", format: "chip" },
  { key: "executed_date", label: "Executed", format: "date" },
  { key: "agent_name", label: "Agent or Proxy" },
  { key: "document_location", label: "Document Location" },
];

const FIELDS = [
  { key: "directive_type", label: "Directive Type", type: "select", options: DIRECTIVE_TYPES, required: true },
  { key: "status", label: "Status", type: "select", options: STATUSES, required: true },
  { key: "executed_date", label: "Executed Date", type: "date" },
  { key: "reviewed_date", label: "Last Reviewed", type: "date" },
  { key: "expires_date", label: "Expiration Date", type: "date" },
  { key: "agent_name", label: "Healthcare Agent or Proxy Name" },
  { key: "agent_phone", label: "Agent Phone" },
  { key: "agent_relationship", label: "Agent Relationship" },
  { key: "document_location", label: "Where document is stored", span: 2 },
  { key: "notes", label: "Notes", type: "textarea", span: 2 },
];

export default function AdvanceDirectives({ client }) {
  return (
    <GenericMedicalList
      client={client}
      title="Advance Directives"
      subtitle="Living wills, healthcare proxies, DNR, POLST, and psychiatric advance directives."
      endpointList={(cid) => `/clients/${cid}/advance-directives`}
      endpointCreate={(cid) => `/clients/${cid}/advance-directives`}
      endpointUpdate={(id) => `/advance-directives/${id}`}
      endpointDelete={(id) => `/advance-directives/${id}`}
      columns={COLUMNS}
      formFields={FIELDS}
      defaultForm={DEFAULT}
      testPrefix="advance-directives"
      emptyText="No advance directives on file"
    />
  );
}
